import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Box, Spinner} from '@primer/react'

import styles from './CommentDivider.module.css'

type CommentDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  large?: boolean
}

export const CommentDivider = ({large, isLoading, isHovered}: CommentDividerProps) => (
  <div className={styles.CommentDividerContainer}>
    <Box
      sx={{
        pb: large ? 4 : 3,
      }}
      className={styles.CommentDividerLeftLine}
    />
    {isLoading && <Spinner size={'small'} />}
    {isHovered && !isLoading && (
      <LoadingSkeleton height={'12px'} width={'100%'} className={styles.CommentDividerLoadingSkeleton} />
    )}
    <Box
      sx={{
        pb: large ? 4 : 3,
      }}
      className={styles.CommentDividerRightLine}
    />
  </div>
)

try{ CommentDivider.displayName ||= 'CommentDivider' } catch {}